<template>
    <div class="col-md-9">
        <h1 class="pages__title">General Infos</h1>
        <div class="pages__box">
            <div class="form">
                <ValidationObserver ref="form">
                    <h2 class="profile__title">General</h2>

                    <LogoAvatarUploader
                        :label="'logo'"
                        :logo="generalInfo.logo"
                        :upload-handler="uploadImage"
                        @update-image="updateLogo"
                    />

                    <ValidationProvider
                        class="form-group mb-3"
                        name="Phone"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Phone</label>
                        <input
                            type="tel"
                            v-mask="'+1 (###) ###-####'"
                            v-model="generalInfo.phone"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Phone"></FormError>
                    </ValidationProvider>

                    <ValidationProvider
                        class="form-group mb-3"
                        name="Second Phone"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Second Phone</label>
                        <input
                            type="tel"
                            v-mask="'+1 (###) ###-####'"
                            class="form-control pl-4"
                            v-model="generalInfo.second_phone"
                        >
                        <FormError :error="errors[0]" name="Second Phone"></FormError>
                    </ValidationProvider>

                    <ValidationProvider
                        class="form-group mb-3"
                        name="Email"
                        v-slot="{ errors }"
                        rules="required|email"
                    >
                        <label for="" class="form-label">Email Address</label>
                        <input
                            type="email"
                            class="form-control pl-4"
                            v-model="generalInfo.email"
                        >
                        <FormError :error="errors[0]"  name="Email"></FormError>
                    </ValidationProvider>

                    <div class="form-group mb-3">
                        <label for="" class="form-label">Facebook Link</label>
                        <input type="text" class="form-control" v-model="generalInfo.facebook_link">
                        <span class="form-icon social">
                            <img src="/img/svg/facebook.svg" alt="Facebook Icon" width="24">
                        </span>
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Instagram Link</label>
                        <input type="text" class="form-control" v-model="generalInfo.instagram_link">
                        <span class="form-icon social">
                            <img src="/img/svg/instagram.svg" alt="Instagram Icon" width="24">
                        </span>
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Youtube link</label>
                        <input type="text" class="form-control" v-model="generalInfo.youtube_link">
                        <span class="form-icon social">
                            <img src="/img/svg/youtube.svg" alt="Youtube Icon" width="24">
                        </span>
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Linkedin link</label>
                        <input type="text" class="form-control" v-model="generalInfo.linkedin_link">
                        <span class="form-icon social">
                            <img src="/img/svg/linkedin.svg" alt="Linkedin Icon" width="24">
                        </span>
                    </div>
                    <div class="form-group mb-3">
                        <label for="" class="form-label">X link</label>
                        <input type="text" class="form-control" v-model="generalInfo.x_link">
                        <span class="form-icon social">
                            <img src="/img/svg/x.svg" alt="X Icon" width="24">
                        </span>
                    </div>
                    <BaseButtons
                        :on-cancel="backToPreviousPage"
                        :on-save="validateForm"
                    />

                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
import BaseButtons from "../../Common/BaseButtons.vue";
import AdminPanelService from "../../../services/AdminPanelService";
import ModalHandler from "../../../mixins/ModalHandler";
import FormError from "../../Common/FormError.vue";
import LogoAvatarUploader from "../../Common/ContentFields/LogoAvatarUploader.vue";

export default {
    components: {LogoAvatarUploader, FormError, BaseButtons},
    mixins: [ModalHandler],
    props: {
        info: Object
    },
    data() {
        return {
            generalInfo: {
                phone: null,
                second_phone: null,
                email: null,
                facebook_link: null,
                instagram_link: null,
                youtube_link: null,
                linkedin_link: null,
                x_link: null,
                logo: null,
            }
        }
    },
    methods: {
        updateLogo(result) {
            this.generalInfo.logo = result
        },
        async uploadImage(formData) {
            return await AdminPanelService.uploadLogo(formData)
        },
        async validateForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.updateGeneralInfo()
        },
        async updateGeneralInfo() {
            try {
                await AdminPanelService.updateGeneralInfo(this.generalInfo)
                this.$showSuccessMessage('The general information was updated')
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted() {
         Object.assign(this.generalInfo, this.info)
    }
}
</script>

<style scoped>

</style>
